import Api from "@/service/Api";

class PercoService {
    getByStationId = async (id) => {
        return await Api().get(`perco-info/${id}`)
    }
}

export default new PercoService()